const BACKEND_URLS = {
  prod: 'https://bc-backend-rvt5.onrender.com',
  dev: 'http://localhost:3000',
};

const DEFAULT_BACKEND_ENV = 'prod';

const normalizeBaseUrl = (url) => url.replace(/\/+$/, '');

const resolveBackendBaseUrl = () => {
  const env = (import.meta.env.VITE_BACKEND_ENV || DEFAULT_BACKEND_ENV).toLowerCase();
  const override = import.meta.env.VITE_BACKEND_BASE_URL;
  const base = override || BACKEND_URLS[env] || BACKEND_URLS[DEFAULT_BACKEND_ENV];
  return { env, base: normalizeBaseUrl(base) };
};

const { env: BACKEND_ENV, base: BACKEND_BASE_URL } = resolveBackendBaseUrl();

const backendUrl = (path = '') => {
  if (!path) return BACKEND_BASE_URL;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${BACKEND_BASE_URL}${normalizedPath}`;
};

export { BACKEND_ENV, BACKEND_BASE_URL, backendUrl };
